export const chartColors = ["var(--chart-1)", "var(--chart-2)", "var(--chart-3)", "var(--chart-4)", "var(--chart-5)"] as const;

export const chartBgColors = ["bg-chart-1", "bg-chart-2", "bg-chart-3", "bg-chart-4", "bg-chart-5"] as const;

export function getCreativeFatigueBarColor(level: number): string {
  if (level >= 70) return "bg-destructive";
  if (level >= 50) return "bg-warning";
  return "bg-muted-foreground";
}

export function getPriorityBadgeClass(priority: string): string {
  switch (priority.toLowerCase()) {
    case "critical":
    case "high":
      return "bg-destructive/10 text-destructive";
    case "medium":
    case "warning":
      return "bg-warning/10 text-warning";
    case "low":
      return "bg-blue-100/40 text-blue-600";
    default:
      return "bg-muted text-muted-foreground";
  }
}

export function getScoreStrokeColor(score: number) {
  if (score >= 80) return { stroke: "stroke-success", text: "text-success" };
  if (score > 60) return { stroke: "stroke-warning", text: "text-warning" };
  return { stroke: "stroke-destructive", text: "text-destructive" };
}

export function getScoreBarColor(score: number) {
  if (score >= 80) return "bg-success rounded-full";
  if (score > 60) return "bg-warning rounded-full";
  return "bg-destructive rounded-full";
}

export function getScoreBadgeColor(score: number) {
  if (score >= 80) return { bg: "bg-success/10", text: "text-success" };
  if (score > 60) return { bg: "bg-warning/10", text: "text-warning" };
  return { bg: "bg-destructive/10", text: "text-destructive" };
}

export function getScoreFillColor(score: number) {
  if (score >= 80) return "var(--success)";
  if (score > 60) return "var(--warning)";
  return "var(--destructive)";
}

export function getScoreTextColor(score: number) {
  if (score >= 70) return "text-success";
  if (score >= 50) return "text-warning";
  return "text-destructive";
}

export function getAlertSeverityClass(severity: string): string {
  switch (severity?.toLowerCase()) {
    case "high":
      return "bg-destructive/10 text-destructive border border-destructive/20";
    case "medium":
      return "bg-warning/10 text-warning border border-warning/20";
    default:
      return "bg-muted text-muted-foreground border border-muted-foreground/20 dark:border-muted-foreground/50";
  }
}

export function getBrandCheckStatusClass(status: string): string {
  switch (status) {
    case "approved":
      return "text-success";
    case "flagged":
      return "text-destructive";
    case "review":
      return "text-warning";
    default:
      return "text-muted-foreground";
  }
}

export type NormalizedSentiment = "positive" | "negative" | "neutral" | "unknown";

export function normalizeSentiment(value?: string): NormalizedSentiment {
  const normalized = (value || "").toLowerCase();
  if (normalized.includes("positive")) return "positive";
  if (normalized.includes("negative")) return "negative";
  if (normalized.includes("neutral")) return "neutral";
  return "unknown";
}

export function formatChannelName(channel: string): string {
  return channel
    .split("_")
    .flatMap((w) => w.split("-"))
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}